<template>
  <button :class="{'cursor-pointer': $attrs.onClick}" class="text-red-600">{{ props.text }}</button>
</template>

<script setup>

import {defineProps} from "vue";

const props = defineProps({
  text: {
    type: String,
    required: true
  }
})
</script>


<style scoped>

</style>